import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import * as lodash from 'lodash';

// declare global {
//   const _: typeof lodash;
// }

// (window as any)['_'] = lodash;
// (globalThis as any)['_'] = lodash;

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
